export default __webpack_public_path__ + "static/media/logomarca1.715f4792.png";